'use strict';

/**
 *
 * @name: pinterestShare
 *
 */

function PinterestShareDirective($rootScope, $location, campaignTrackingServ) {

  'ngInject';

  function generateWhatsAppShareLink(scope) {

    var url = location.protocol + '//' + location.host + '/story/' + scope.post.translations[scope.lang].slug;
    url += '?' + campaignTrackingServ.generateTrackingParams('whatsapp', 'mobile', 'share');

    return url;
  }

  return {
    restrict: 'A',
    link: function (scope, element) {

      const links = {
        app: `whatsapp://send?text=${generateWhatsAppShareLink(scope)}`,
        ios: 'https://itunes.apple.com/pl/app/whatsapp-messenger/id310633997?mt=8',
        android: 'https://play.google.com/store/apps/details?id=com.whatsapp'
      }
      const isAndroid = navigator.userAgent.match(/Android/)

      element.click(function () {
        window.location.href = links.app
        setTimeout(() => {
          window.location.href = links[isAndroid ? 'android' : 'ios']
        }, 200);
      });
    }
  };
}

export default PinterestShareDirective;



// WEBPACK FOOTER //
// ./app/components/nn-social/nn-whatsapp-share.directive.js